import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { ExternalLink } from 'lucide-react';
import ConditioningSession from './ConditioningSession';
import MobilitySession from './MobilitySession';

const MoveDetailModal = ({ move, isOpen, onClose }) => {
  const [showConditioning, setShowConditioning] = useState(false);
  const [showMobility, setShowMobility] = useState(false);
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') return document.body.classList.contains('light') ? 'light' : 'dark';
    return 'dark';
  });

  const getTypeColor = (type) => {
    const colors = {
      toprock: 'bg-blue-100 text-blue-800 border-blue-200',
      footwork: 'bg-green-100 text-green-800 border-green-200',
      powermoves: 'bg-red-100 text-red-800 border-red-200',
      freezes: 'bg-purple-100 text-purple-800 border-purple-200',
      transitions: 'bg-orange-100 text-orange-800 border-orange-200',
      flips: 'bg-yellow-100 text-yellow-800 border-yellow-200'
    };
    return colors[type] || 'bg-gray-100 text-gray-800 border-gray-200';
  };

  const handleClose = () => {
    setShowConditioning(false);
    setShowMobility(false);
    onClose();
  };

  if (!move) return null;

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className={`max-w-lg border-2 bg-white text-black`}>
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center">
            {move.name}
          </DialogTitle>
        </DialogHeader>
        {!showConditioning && !showMobility ? (
          <div className="space-y-3">
            <div className="flex gap-2 items-center">
              <Badge className={`${getTypeColor(move.type)} font-medium`}>{move.type}</Badge>
            </div>
            <p className={`text-sm leading-relaxed ${theme === 'light' ? 'text-gray-700' : 'text-gray-300'}`}>
              {move.description}
            </p>
            {move.origin && (
              <div>
                <span className={`font-medium text-sm ${theme === 'light' ? 'text-gray-800' : 'text-gray-300'}`}>Origin:</span>
                <p className={`text-sm ${theme === 'light' ? 'text-gray-700' : 'text-gray-400'}`}>{move.origin}</p>
              </div>
            )}
            {move.videoLink && (
              <Button
                variant="outline"
                size="sm"
                className={`w-full transition-all duration-200 ${theme === 'light' ? 'bg-white text-black border-black hover:bg-gray-100' : 'bg-black text-white border-white hover:bg-gray-800'}`}
                onClick={() => window.open(move.videoLink, '_blank')}
              >
                <ExternalLink className="w-4 h-4 mr-2" />
                Watch Video
              </Button>
            )}
            <div className="space-y-2 mt-4">
              <Button onClick={() => setShowConditioning(true)} className="w-full bg-blue-600 text-white font-bold">
                Start Conditioning Session
              </Button>
              <Button onClick={() => setShowMobility(true)} className="w-full bg-purple-600 text-white font-bold">
                Start Mobility Session
              </Button>
            </div>
          </div>
        ) : showConditioning ? (
          <ConditioningSession move={move.name} level="beginner" onClose={() => setShowConditioning(false)} />
        ) : (
          <MobilitySess ion move={move.name} level="beginner" onClose={() => setShowMobility(false)} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MoveDetailModal; 